<template>
  <v-alert show v-if="visible" variant="red" align="center">{{
    $t('white-label.globalMessages.streamingError')
  }}</v-alert>
</template>

<script>
export default {
  name: 'c-streaming-error',
  props: {
    show: Boolean
  },
  watch: {
    show(val) {
      this.throttledChangeStatus(val);
    }
  },
  data() {
    return {
      throttledChangeStatus: this._.throttle(visible => (this.visible = visible), 3000, { leading: false }),
      visible: this.show
    };
  }
};
</script>
